import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
  HttpResponse
} from '@angular/common/http';
import { of, Observable } from 'rxjs';
import {
  RequestHeaders,
  CacheConstant,
  UserDeviceConstant
} from '../constants/app.constant';
import { AuthService } from '../services/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppUtilService } from '../utils/app-util.service';
import '../utils/app-prototype';
import {
  AppConfigService,
  Configuration
} from '../services/init/app-config.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  /***************Constructor***************/
  constructor(
    private configService: AppConfigService,
    private authService: AuthService,
    private deviceDetectorService: DeviceDetectorService,
    private appUtil: AppUtilService
  ) {}
  /***************Constructor***************/

  /******************Implementation Methods******************/

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request to add the new header.
    const cloneRequest = request.clone({
      setHeaders: this.getRequestHeaders(request.headers, request)
    });
    // Pass on the cloned request instead of the original request.
    return next.handle(cloneRequest).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.verifyAuthToken(event);
          }
        },
        (error: any) => {}
      )
    );
  }

  /******************Implementation Methods******************/

  /******************Private Methods******************/

  private getRequestHeaders(headers: HttpHeaders, request) {

    const requestHeaders = {};
    requestHeaders[RequestHeaders.ContentType] = 'application/json';
    requestHeaders[RequestHeaders.AgentType] = this.getUserAgentInfo();
    requestHeaders[RequestHeaders.ApiKey] = this.configService.get(
      Configuration.API_KEY
    );

    if ((request.url.indexOf(this.configService.get(Configuration.AXWAY_API_URL)) != 0) ) {
      requestHeaders[RequestHeaders.BUID] = this.configService.get(
        Configuration.BUID
      );
    }

    const tokens = this.authService.getAuthorizationTokens();

    if (tokens[RequestHeaders.AccessToken]) {
      requestHeaders[RequestHeaders.AccessToken] =
        tokens[RequestHeaders.AccessToken];
    }

    if (headers.keys().length > 0) {
      headers.keys().forEach(key => {
        requestHeaders[key] = headers.get(key);
      });
    }

    return requestHeaders;
  }

  private verifyAuthToken(response: HttpResponse<any>) {
    const tokens = this.authService.getAuthorizationTokens();

    const accessTokenKey = response.headers
      .keys()
      .filter(
        key => key.toLowerCase() === RequestHeaders.AccessToken.toLowerCase()
      )[0];

    if (accessTokenKey) {
      tokens[RequestHeaders.AccessToken] =
        response.headers.get(accessTokenKey) ||
        tokens[RequestHeaders.AccessToken];

      AppUtilService.cache.set(CacheConstant.Auth_Tokens, tokens);
    }
  }

  private getUserAgentInfo() {
    const device = this.deviceDetectorService.isDesktop()
      ? UserDeviceConstant.Desktop
      : this.deviceDetectorService.isTablet()
        ? UserDeviceConstant.Tablet
        : UserDeviceConstant.Mobile;
    const os = this.deviceDetectorService.os;
    const browser =
      this.deviceDetectorService.browser +
      ' ' +
      this.deviceDetectorService.browser_version;

    return device + ', ' + os.toPascalCase() + ', ' + browser.toPascalCase();
  }

  /******************Private Methods******************/
}
